module.exports = __webpack_public_path__ + "static/img/step-1031.55edc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-1031.png
// module id = 9IXp
// module chunks = 1